import React from "react";

type HeadingProps = {
  text: string;
  className?: string;
};

const Heading: React.FC<HeadingProps> = ({ text, className = "" }) => {
  return <div className={`text-2xl font-bold ${className}`}>{text}</div>;
};

export default Heading;
